import { render } from "./PasswordForm.vue?vue&type=template&id=f939b132&ts=true"
import script from "./PasswordForm.vue?vue&type=script&lang=ts"
export * from "./PasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__